import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/images/650X340.png';
import _imports_1 from '../assets/images/homePage/data.svg';
import _imports_2 from '../assets/images/data.png';
import _imports_3 from '../assets/images/Supervision.png';
import _imports_4 from '../assets/images/letter.png';
import _imports_5 from '../assets/images/background.png';
import _imports_6 from '../assets/images/professional.png';
import _imports_7 from '../assets/images/serve.png';
import _imports_8 from '../assets/images/technology.png';
import _imports_9 from '../assets/images/data-big.png';
const _withScopeId = n => (_pushScopeId("data-v-655f4e14"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "roll",
  ref: "roll"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "sj"
};
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"lh-index\" data-v-655f4e14><div class=\"index-table\" data-v-655f4e14><h4 class=\"home-ctitle\" data-v-655f4e14>联合智评指数</h4><p class=\"title\" data-v-655f4e14>INDEX</p><div class=\"box introduce\" id=\"aa\" data-v-655f4e14> 联合智评于2021年7月起陆续发布现金管理类指数、固定收益类指数、混合类指数、权益类指数以及兑付指数，细分为24个理财产品指数，为投资者提供更加准确、全面的市场参考，助力投资者做出明智的投资决策。指数数据详情请联系客户经理获取。 </div></div></div><div class=\"lh-ptjj\" data-v-655f4e14><h4 class=\"home-ctitle\" data-v-655f4e14>联合智评金融数据平台</h4><p class=\"title\" data-v-655f4e14>FINANCIAL DATA PLATFORM</p><div class=\"desc box ptjj\" data-v-655f4e14><div class=\"desc-text desc-left\" data-v-655f4e14><h4 class=\"title-cptjj\" data-v-655f4e14>平台简介</h4><h6 class=\"title-eptjj\" data-v-655f4e14>PLATFROM INTRODUCTION</h6><p data-v-655f4e14> 联合智评是联合征信旗下的资管服务平台，面向银行、理财子公司及其他资管机构提供数据服务、研究服务以及风控服务。 </p><p data-v-655f4e14> 联合智评涵盖银行理财数据字段超过400个，数据维度极广，并以全面、准确、及时、 易用、安全作为银行理财数据库的开发标准和维护原则，旨在打造一个更加数字化、 智能化的银行理财服务平台。 </p><p data-v-655f4e14> 联合智评可在具体投向、产品研发、创新案例、发行定价、销售管理、客户分析、 投后监管、绩效评价等八大方面为发行机构提供重要帮助。 </p></div><div class=\"desc-right\" data-v-655f4e14><img src=\"" + _imports_0 + "\" alt=\"\" class=\"desc-img\" data-v-655f4e14></div></div></div>", 2);
const _hoisted_6 = {
  class: "lh-service"
};
const _hoisted_7 = {
  class: "service-main"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", {
  class: "home-ctitle"
}, "我们的服务", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "OUR SERVICE", -1));
const _hoisted_10 = {
  class: "card-service box"
};
const _hoisted_11 = {
  class: "card"
};
const _hoisted_12 = {
  class: "desc-left service-posi"
};
const _hoisted_13 = {
  style: {
    "text-align": "center"
  }
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));
const _hoisted_15 = {
  style: {
    "color": "#153578",
    "font-size": "18px"
  }
};
const _hoisted_16 = {
  class: "sjfw-all"
};
const _hoisted_17 = {
  class: "sjfw-title"
};
const _hoisted_18 = {
  class: "sjfw-ul"
};
const _hoisted_19 = {
  class: "desc-right other-service cardright"
};
const _hoisted_20 = {
  class: "other-img"
};
const _hoisted_21 = ["src"];
const _hoisted_22 = {
  class: "other-desc"
};
const _hoisted_23 = {
  class: "lh-advantage"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", {
  class: "home-ctitle"
}, "我们的优势", -1));
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "OUR ADVANTAGE", -1));
const _hoisted_26 = {
  class: "fwtd box ys"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "desc-left fwtd-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  class: ""
})], -1));
const _hoisted_28 = {
  class: "fwtd-desc desc-right"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", {
  class: "title-cptjj"
}, "数据服务特点", -1));
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h6", {
  class: "title-eptjj"
}, "DATA SERVICE", -1));
const _hoisted_31 = ["src"];
const _hoisted_32 = /*#__PURE__*/_createStaticVNode("<div class=\"lh-back\" data-v-655f4e14><div class=\"back box bj\" data-v-655f4e14><div class=\"back-desc desc-left\" data-v-655f4e14><h4 class=\"title-cptjj\" data-v-655f4e14>股东背景</h4><h6 class=\"title-eptjj\" data-v-655f4e14>SHAREHOLDER BACKGROUND</h6><p class=\"gdbj-desc\" data-v-655f4e14><img src=\"" + _imports_3 + "\" alt=\"\" data-v-655f4e14><span data-v-655f4e14>国资背景的联合信用倾力打造</span></p><p class=\"gdbj-desc\" data-v-655f4e14><img src=\"" + _imports_4 + "\" alt=\"\" data-v-655f4e14><span data-v-655f4e14>信用风险市场深耕二十年</span></p><p class=\"gdbj-desc\" data-v-655f4e14><img src=\"" + _imports_3 + "\" alt=\"\" data-v-655f4e14><span data-v-655f4e14>资本实力雄厚，市场占有率居前</span></p></div><div class=\"desc-right\" data-v-655f4e14><img src=\"" + _imports_5 + "\" alt=\"\" class=\"back-img\" data-v-655f4e14></div></div></div><div class=\"lh-professional\" data-v-655f4e14><div class=\"pro box js\" data-v-655f4e14><div class=\"desc-left pro-img\" data-v-655f4e14><img src=\"" + _imports_6 + "\" alt=\"\" class=\"pro-image\" data-v-655f4e14></div><div class=\"pro-desc desc-right\" data-v-655f4e14><h4 class=\"title-cptjj\" data-v-655f4e14>专业技术</h4><h6 class=\"title-eptjj\" data-v-655f4e14>EXPERTISE</h6><p class=\"gdbj-desc\" data-v-655f4e14><img src=\"" + _imports_7 + "\" alt=\"\" data-v-655f4e14><span data-v-655f4e14>传承联合信用服务理念</span></p><p class=\"gdbj-desc\" data-v-655f4e14><img src=\"" + _imports_8 + "\" alt=\"\" data-v-655f4e14><span data-v-655f4e14>二十年信用技术体系积累</span></p><p class=\"gdbj-desc\" data-v-655f4e14><img src=\"" + _imports_9 + "\" alt=\"\" data-v-655f4e14><span data-v-655f4e14>专注理财产品测评、数据及风控服务、理财领域研究</span></p></div></div></div>", 2);
import topBar from '../components/topBar';
import bottomBar from '@/components/bottomBar';
// import indexCarousel from '@/components/indexCarousel.vue';
// import homeTable from '@/components/homeTable.vue';

// import {getIndexList} from '../interface/api'
import { onMounted, reactive, ref, watch } from 'vue';
export default {
  __name: 'homePage',
  setup(__props) {
    onMounted(() => {
      // getList()
      screenWidth.value = window.innerWidth;
      bannerHeight.value = 520 / 1920 * screenWidth.value;
      window.onresize = () => {
        screenWidth.value = window.innerWidth;
        bannerHeight.value = 520 / 1920 * screenWidth.value;
      };
      window.addEventListener('resize', handleResize);

      // console.log('尺寸尺寸',window.innerWidth);

      window.addEventListener('resize', handleClientWidth);
    });
    let mobileWidth = ref(0);
    // 根据屏幕尺寸大小调整html的font-size
    const handleClientWidth = () => {
      mobileWidth.value = document.documentElement.clientWidth;
    };
    watch(mobileWidth, (n, o) => {
      // let width = document.documentElement.clientWidth
      // console.log('尺寸改变了',n,o);
      mobileWidth.value = n;
      document.documentElement.style.fontSize = mobileWidth / 10 + 'px';
    });
    const handleResize = () => {
      // console.log('实时刷新一下',window.innerWidth);
      browserWindow.value = window.innerWidth;
    };
    let browserWindow = ref(0);
    watch(browserWindow, (n, o) => {
      // console.log('刷新刷新');

      let homeTable = document.getElementById('aa');
      let card = document.querySelector('.card');
      let ptjj = document.querySelector('.ptjj');
      let ys = document.querySelector('.ys');
      let bj = document.querySelector('.bj');
      let js = document.querySelector('.js');
      if (document.body.clientWidth < 1090) {
        // console.log('小于了 1090,放大了样式');
        // card.classList.add('cards')
        // console.log('card',card);
        card.classList.add('cards');
        ptjj.classList.add('cards');
        ys.classList.add('cards');
        bj.classList.add('cards');
        js.classList.add('cards');
        homeTable.style.width = document.body.clientWidth + 'px';
        // console.log('宽度是',homeTable.style.width);
      } else {
        // console.log('缩小了样式');
        homeTable.style.width = '1100px';
        card.classList.remove('cards');
        ptjj.classList.remove('cards');
        ys.classList.remove('cards');
        bj.classList.remove('cards');
        js.classList.remove('cards');
      }
    });
    let bannerHeight = ref(0); // banner图高度
    let screenWidth = ref(0); // 屏幕宽度
    // const indexData = ref([])  // 智评指数总数据

    const slider = reactive([
    // banner图
    {
      urlId: 1,
      img: require('@/assets/images/slider/zslb-1.jpg')
    }, {
      urlId: 2,
      img: require('@/assets/images/slider/bg-1.png')
    }, {
      urlId: 4,
      img: require('@/assets/images/slider/zslb-2.jpg')
    }, {
      urlId: 3,
      img: require('@/assets/images/slider/bg-2.png')
    }]);
    const sjService = reactive([
    // 数据服务内容
    {
      title: '数据服务',
      class: 'sjfw',
      list: [{
        subTitle: '特色数据',
        sublist: [{
          label: "底层资产"
        }, {
          label: "实际募集规模"
        }, {
          label: "代销数据"
        }, {
          label: "实时净值"
        }, {
          label: "浮动管理费"
        }, {
          label: " 存续规模"
        }]
      }, {
        subTitle: '特色功能',
        sublist: [{
          label: "理财产品查询"
        }, {
          label: "理财机构查询"
        }, {
          label: "大数据统计"
        }, {
          label: "产品收益跟踪"
        }, {
          label: "产品定价"
        }, {
          label: "创新案例"
        }]
      }, {
        subTitle: '定制数据',
        sublist: [{
          label: "对标机构产品收益表现"
        }, {
          label: "产品兑付情况"
        }, {
          label: "代销产品情况"
        }, {
          label: "平均费用"
        }, {
          label: "非标资产信息"
        }, {
          label: "分红信息"
        }]
      }]
    }]);
    const otherService = reactive([
    // 风控服务内容
    {
      title: '风控服务',
      class: 'fkfw',
      img: require('../assets/images/homePage/control.svg'),
      list: [{
        label: "银行理财产品评级"
      }, {
        label: "银行理财产品风险估值"
      }, {
        label: "银行理财净值模拟"
      }]
    }, {
      title: '研发与咨询服务',
      class: 'yfzxfw',
      img: require('../assets/images/homePage/development.png'),
      list: [{
        label: "定制报告"
      }, {
        label: "定期研究报告"
      }, {
        label: "专题研究报告"
      }]
    }, {
      title: '品牌合作&拓展',
      class: 'pphzfw',
      img: require('../assets/images/homePage/promotion.png'),
      list: [{
        label: "联合理财指数"
      }, {
        label: "研究机构、科研院校合作"
      }, {
        label: "媒体宣传"
      }, {
        label: "资管行业交流会、沙龙、论坛"
      }]
    }]);
    const advantage = reactive([
    // 我们的优势 内容
    {
      title: '全市场覆盖',
      detail: '日均新增产品超1000支，更新净值和公告超10,000条',
      img: require('../assets/images/bigdata.png')
    }, {
      title: '产品维度深',
      detail: '10大维度，超400项数据指标，深度解析银行理财',
      img: require('../assets/images/vector.png')
    }, {
      title: '更新T+1',
      detail: '产品数据24小时内更新，新发与存量产品全覆盖',
      img: require('../assets/images/update.png')
    }, {
      title: '数据准确度高',
      detail: '技术爬取+分类入库+逻辑校对+实时报错，四大流程确保数据准确度高达99%',
      img: require('../assets/images/icon_to.png')
    }, {
      title: '数据结构化',
      detail: ' 对公开数据内容进行字段拆解和结构化处理，便于数据分析',
      img: require('../assets/images/icon_change.png')
    }]);

    // const tableHeader = reactive([  // 首页的表格表头
    //     {
    //         label:'最新收盘',
    //         prop:'indexValue',
    //         class:'indexValue'
    //     }
    // ])

    // const getList = async () => {  // 获取智评智数列表总数据
    //     await getIndexList().then(res=>{
    //         if(res.data.code == 2000){
    //             // console.log('获取数据~~~~~~~~~',res);
    //             // Object.keys(res.data.data).forEach(item => {
    //             //     indexData.value.push(res.data.data[item])
    //             // })
    //             indexData.value = res.data.data.rows
    //         }
    //     })
    // }

    return (_ctx, _cache) => {
      const _component_el_carousel_item = _resolveComponent("el-carousel-item");
      const _component_el_carousel = _resolveComponent("el-carousel");
      const _component_el_card = _resolveComponent("el-card");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_unref(topBar)), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_carousel, {
        class: "lh-carousel",
        ref: "carousel",
        height: _unref(bannerHeight) + 'px'
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slider, item => {
          return _openBlock(), _createBlock(_component_el_carousel_item, {
            key: item.urlId
          }, {
            default: _withCtx(() => [_createElementVNode("img", {
              src: item.img,
              alt: ""
            }, null, 8, _hoisted_2)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }, 8, ["height"])], 512), _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _hoisted_9, _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sjService, (item, index) => {
        return _openBlock(), _createBlock(_component_el_card, {
          shadow: "hover",
          key: index,
          class: _normalizeClass(item.class)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("p", _hoisted_15, _toDisplayString(item.title), 1)]), _createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (subItem, subIndex) => {
            return _openBlock(), _createElementBlock("div", {
              key: subIndex,
              class: "sjfw-area"
            }, [_createElementVNode("p", _hoisted_17, _toDisplayString(subItem.subTitle), 1), _createElementVNode("ul", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subItem.sublist, (listItem, listIndex) => {
              return _openBlock(), _createElementBlock("li", {
                key: listIndex,
                class: "sjfw-subtitle"
              }, _toDisplayString(listItem.label), 1);
            }), 128))])]);
          }), 128))])]),
          _: 2
        }, 1032, ["class"]);
      }), 128))]), _createElementVNode("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otherService, (item, index) => {
        return _openBlock(), _createBlock(_component_el_card, {
          shadow: "hover",
          key: index,
          class: _normalizeClass([item.class, "other"]),
          style: {}
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_20, [_createElementVNode("img", {
            src: item.img,
            alt: ""
          }, null, 8, _hoisted_21)]), _createElementVNode("div", _hoisted_22, [_createElementVNode("p", null, _toDisplayString(item.title), 1), _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (subItem, subIndex) => {
            return _openBlock(), _createElementBlock("li", {
              key: subIndex,
              class: "sjfw-subtitle"
            }, [_createElementVNode("span", null, _toDisplayString(subItem.label), 1)]);
          }), 128))])])]),
          _: 2
        }, 1032, ["class"]);
      }), 128))])])])])]), _createElementVNode("div", _hoisted_23, [_hoisted_24, _hoisted_25, _createElementVNode("div", _hoisted_26, [_hoisted_27, _createElementVNode("div", _hoisted_28, [_hoisted_29, _hoisted_30, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(advantage, (item, index) => {
        return _openBlock(), _createElementBlock("dl", {
          key: index
        }, [_createElementVNode("dt", null, [_createElementVNode("img", {
          src: item.img,
          alt: "",
          class: "td-img"
        }, null, 8, _hoisted_31), _createTextVNode(" " + _toDisplayString(item.title), 1)]), _createElementVNode("dd", null, _toDisplayString(item.detail), 1)]);
      }), 128))])])]), _hoisted_32]), _createVNode(_unref(bottomBar))], 64);
    };
  }
};